/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_5927fff2"]'><cube-button primary icon="like">图标按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5927fff2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5927fff2"}
  /** script content **/
  require("./btn-icon.mpx.js?isComponent&outputPath=components%2Fbtn-icon5927fff2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-icon5927fff2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5927fff2"],
    ctorType: "component",
    outputPath: "components/btn-icon5927fff2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>